export default __webpack_public_path__ + "locales/pl/SalesDepartmentRequestDialog.json?hash=f2a14c7e54c7bf3112a4c954fb1a2ac2";